import {
  CreditCard,
  ShoppingBag,
  XCircle,
  Truck,
  MapPin,
  CheckCircle,
  ShoppingCart,
  UserPlus,
  RotateCcw,
  Sparkles,
  type LucideIcon,
} from 'lucide-react';

export const PLAYBOOK_ICON_MAP: Record<string, LucideIcon> = {
  'credit-card': CreditCard,
  'shopping-bag': ShoppingBag,
  'x-circle': XCircle,
  'truck': Truck,
  'map-pin': MapPin,
  'check-circle': CheckCircle,
  'shopping-cart': ShoppingCart,
  'user-plus': UserPlus,
  'rotate-ccw': RotateCcw,
};

export function resolvePlaybookIcon(icon: string | undefined | null): LucideIcon {
  if (!icon) return Sparkles;
  return PLAYBOOK_ICON_MAP[icon] ?? Sparkles;
}
